// Requires base font size in local repo set to 16px
export var pxToRem = function (pxSize, base) {
    var baseFont = base || 16;
    return "".concat(pxSize / baseFont, "rem");
};
